import axios from 'axios';
import util from '../util/asymmetric';

const poscrm = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

// ✅ ใส่ service token ทุก request
poscrm.interceptors.request.use((config) => {
  config.headers.token = util.asymmetric(); // fresh ทุกครั้ง
  return config;
});

poscrm.interceptors.response.use(
  (response) => {
    if (response.data?.error?.code === 403) {
      alert('ติดต่อพนักงานของเราเพื่อขอความช่วยเหลือ');
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = '/texp?errorCode=-2002';
    }
    return response;
  },
  (error) => {
    console.error('poscrm error:', {
      message: error?.message,
      url: error?.config?.baseURL + error?.config?.url,
      status: error?.response?.status,
    });
    return Promise.reject(error);
  }
);

export default poscrm;
